var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.44922V7.44922V3.44922ZM3 5.44922H7H3ZM6 17.4492V21.4492V17.4492ZM4 19.4492H8H4ZM13 3.44922L15.286 10.3062L21 12.4492L15.286 14.5922L13 21.4492L10.714 14.5922L5 12.4492L10.714 10.3062L13 3.44922Z",
    stroke: "url(#paint0_linear_15452_95883)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15452_95883",
    x1: 14.577,
    y1: 1.45669,
    x2: 9.00687,
    y2: 6.70853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71ABEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.586fc4900c3dc7135cbdf6494f614ff7.svg";
export { ForwardRef as ReactComponent };